'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Paragraph-module_paragraph__a9aT5{color:#666;font-family:inherit;font-size:.875rem;font-weight:400;line-height:1;margin:.75rem 0}";
var styles = {"paragraph":"Paragraph-module_paragraph__a9aT5"};
styleInject["default"](css_248z, '9edaf000-c2cb-4d81-a48c-a90ba5efc8ab');

exports["default"] = styles;
